module.exports = __webpack_public_path__ + "static/img/icon_time.8eae10ca.png";